import React from 'react';
import { useParams, Redirect, useLocation } from 'react-router-dom';
import { useAuthContext } from 'context/AuthContext';
import { sendAmplitudeData } from 'util/amplitude';

export default function MagicLinkLogin() {
  const { magicLinkToken } = useParams();
  const { search: query } = useLocation();
  const [gotoLink, setGotoLink] = React.useState();
  const auth = useAuthContext();
  React.useEffect(() => {
    gotoLink ||
      auth
        .loginMagicLink({ magicLinkToken, query })
        .then(({ link, pageType }) => {
          sendAmplitudeData('Magic Link opened', {
            link: link,
          });
          setGotoLink(
            (pageType || 'magicscreen') &&
              (`/${pageType || 'magicscreen'}${link}` || undefined)
          );
        })
        .catch((error) => alert(error));
  }, [magicLinkToken, gotoLink]);

  return !!gotoLink && <Redirect to={gotoLink} />;
}
